import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import translations from "../../locals/translations.json";
import { Globe,ChevronDown } from "lucide-react";
const NotificationBar = ({ isLiveBidPage = false, auctionData = null }) => {
  const { isAuthenticated, user } = useAuth();
  const { showWarning } = useToast();
  const navigate = useNavigate();
  const [isLanguageOpen, setIsLanguageOpen] = React.useState(false);
  const { language, setLanguage, translate } = useLanguage();


  const currentLanguageInfo = {
    en: { label: "English", flag: "us" },
    ar: { label: "العربية", flag: "sa" },
  };
   const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setIsLanguageOpen(false);
  };

  // const handleJoinNow = () => {
    // Check if user is not logged in or is a seller
    // if (!isAuthenticated || user?.userType === "seller") {
    //   showWarning("Log in as buyer to join auction", {
    //     duration: 3000,
    //   });
    //   return;
    // }

    // If user is a buyer, redirect to auction page
  //   if (user?.userType === "buyer") {
  //     navigate("/auctions");
  //   }
  // };
  return (
   <div className='bg-primary h-[40px] sticky top-0 z-[40] flex items-center justify-center'>

      {/* Container with max width */}
    <div className='w-full max-w-6xl mx-auto flex items-center gap-3 justify-between'>

        {/* Marquee content that will scroll */}
        <div className=' overflow-hidden'>
          <div className='animate-marquee  flex items-center space-x-2 md:space-x-8 lg:space-x-12 font-Poppins   md:text-[22px] text-white whitespace-nowrap'>
            {isLiveBidPage && auctionData ? (
              <>
                <div className=''>
                  🏷️ Live Auction: {auctionData.auctionName || "Live Auction"}
                </div>

                <div className='border-[1px] h-4 md:h-8 border-r border-[#FFFFFF]' />

                <div className=''>🔥 Lane:{auctionData?.laneName || "-"}</div>
              </>
            ) : (
              <>
                <div className=' text-sm md:text-lg'>
                  🏷️ {translations[language].home.notification.exclusiveDeals}
                </div>

                <div className='border-[1px] h-4 md:h-8 border-r border-[#FFFFFF]' />

                <div className=' text-sm md:text-lg'>
                  🔥 {translations[language].home.notification.joinNow}
                </div>
              </>
            )}
          </div>
        </div>

        {/* <button
          onClick={handleJoinNow}
          className='bg-black text-white p-[10px]   md:text-[16px] font-normal flex-shrink-0 transition-colors duration-200 ml-4 skew-x-[-12deg] mx-4  border-[2px] border-[#FFFFFF] hover:bg-primary '
        >
          Join Now
        </button> */}
        <div className='relative language-menu'>
              <button
                onClick={() => setIsLanguageOpen(!isLanguageOpen)}
                className='flex items-center space-x-1 sm:space-x-2 text-white hover:text-gray-300 transition-colors duration-200'
              >
                <Globe className='w-3 h-3 sm:w-4 sm:h-4 md:w-4 md:h-4' />
                <span className='arabic-text text-[10px] sm:text-xs md:text-sm hidden sm:inline'>
                  {currentLanguageInfo[language].label}
                </span>
                <img
                  src={`https://flagcdn.com/${currentLanguageInfo[language].flag}.svg`}
                  alt='Flag'
                  className='w-3 h-2 sm:w-4 sm:h-3 md:w-5 md:h-3'
                />
                <ChevronDown className='w-2 h-2 sm:w-3 sm:h-3 md:w-3 md:h-3' />
              </button>

              {isLanguageOpen && (
                <div className='absolute right-0 mt-2 w-32 sm:w-36 md:w-40 bg-white rounded-md shadow-lg py-1 z-50 min-w-max'>
                  <button
                    onClick={() => handleLanguageChange("en")}
                    className='block w-full text-left px-3 py-2 text-xs sm:text-sm md:text-base text-primary hover:bg-gray-100 whitespace-nowrap'
                  >
                    English
                  </button>
                  <button
                    onClick={() => handleLanguageChange("ar")}
                    className='block w-full text-left px-3 py-2 text-xs sm:text-sm md:text-base text-primary hover:bg-gray-100 arabic-text whitespace-nowrap'
                  >
                    العربية
                  </button>
                </div>
              )}
            </div>
      </div>
    </div>
  );
};

export default NotificationBar;